var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDivider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "56px",
    viewBox: "0 0 24 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delivery Tracker Chevron Revised") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delivery-Tracker-Chevron-Revised",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "left",
    fill: "#80DDDD",
    points: "0 0 16 28 0 56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "divider",
    d: "M0,0 L16,28 L0,56 L8,56 C17.3333333,40 22.3333333,31.3333333 23,30 C24,28 24,28 23,26 C22.3333333,24.6666667 17.3333333,16 8,0 L0,0 Z",
    fill: "#008383"
  }), /*#__PURE__*/React.createElement("path", {
    className: "right",
    d: "M24,30 L24,56 L8,56 L22.9333333,28 L8,0 L24,0 L24,30 Z",
    fill: "#003838"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDivider);
export default __webpack_public_path__ + "static/media/chevron-divider.cce85e97.svg";
export { ForwardRef as ReactComponent };